import { render, staticRenderFns } from "./PromptItem.vue?vue&type=template&id=cc9128ee&scoped=true"
import script from "./PromptItem.vue?vue&type=script&lang=js"
export * from "./PromptItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9128ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc9128ee')) {
      api.createRecord('cc9128ee', component.options)
    } else {
      api.reload('cc9128ee', component.options)
    }
    module.hot.accept("./PromptItem.vue?vue&type=template&id=cc9128ee&scoped=true", function () {
      api.rerender('cc9128ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/fortune/ai-prompt/components/PromptItem.vue"
export default component.exports